// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Login_background_2kmz5{position:relative;width:100%;min-height:100vh;background:linear-gradient(0deg,#2f4787,#5583ee)}", ""]);
// Exports
exports.locals = {
	"background": "Login_background_2kmz5"
};
module.exports = exports;
